import Vue from 'vue'
import Router from 'vue-router'


//import SequenceTable from '../components/SequenceTable'
import Workflow from '../components/Workflow'
/*import Tasks from '../components/Tasks'
import Samples from '../components/Samples'
import LogMonitor from '../components/LogMonitor'
import CentrifugeControl from '../components/CentrifugeControl'
import SolventManagement from '../components/SolventManagement'
import PumpSettings from '../components/PumpSettings'
import DeviceLocking from '../components/DeviceLocking'
import ShakerControl from '../components/ShakerControl'
import BalanceControl from '../components/BalanceControl'
import FilterDispenserControl from '../components/FilterDispenserControl'
import HPLCFeederControl from '../components/HPLCFeederControl'
import HandlerControl from '../components/HandlerControl'
import Teaching from '../components/Teaching'
import MaintenanceMonitor from '../components/MaintenanceMonitor'
import OperationStatusPanel from '../components/OperationStatusPanel'
import ReferenceDataViewer from '../components/ReferenceDataViewer'
import InputOutputControl from '../components/InputOutputControl'
import ConfigAdminTool from '../components/ConfigAdminTool'
import SampleLogViewer from '../components/SampleLogViewer'
import PumpFactor from '../components/PumpFactor';
import DispenseStatistics from '../components/DispenseStatistics';
import Empower from '../components/Empower';
import LayoutViewer from '../components/LayoutViewer';
import MissingConsumables from '../components/MissingConsumables';
import Jog from '../components/Jog';
import MachineSettings from '../components/MachineSettings';
import WorkflowArchive from '../components/WorkflowArchive';
import Manual from '../components/Manual';
import MaintenanceSchedule from '../components/MaintenanceSchedule';
import UserSettings from '../components/UserSettings';
import AllUserSettings from '../components/AllUserSettings';
import UserLog from '../components/UserLog';
import Ticket from '../components/Ticket';
import ReleaseNotes from '../components/ReleaseNotes';
import VialReposition from '../components/VialReposition';*/

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    /*{ path: '/manual', component: Manual },
    { path: '/maintenanceschedule', component: MaintenanceSchedule },
    { path: '/sequencetable', component: SequenceTable },*/
    { path: '/', component: Workflow },
    /*{ path: '/tasks', component: Tasks },
    { path: '/samples', component: Samples },
    { path: '/logmonitor', component: LogMonitor },
    { path: '/centrifugecontrol', component: CentrifugeControl },
    { path: '/solventmanagement', component: SolventManagement },
    { path: '/pumpsettings', component: PumpSettings },
    { path: '/devicelocking', component: DeviceLocking },
    { path: '/shakercontrol', component: ShakerControl },
    { path: '/balancecontrol', component: BalanceControl },
    { path: '/filterdispensercontrol', component: FilterDispenserControl },
    { path: '/uplcfeedercontrol', component: HPLCFeederControl },
    { path: '/handlercontrol', component: HandlerControl },
    { path: '/teaching', component: Teaching },
    { path: '/maintenancemonitor', component: MaintenanceMonitor },
    { path: '/operationstatuspanel', component: OperationStatusPanel },
    { path: '/referencedataviewer', component: ReferenceDataViewer },
    { path: '/inputoutputcontrol', component: InputOutputControl },
    { path: '/samplelogviewer', component: SampleLogViewer },
    { path: '/samplelogviewer/:project/:sample/:id', component: SampleLogViewer },
    { path: '/pumpfactor/:solvent', component: PumpFactor },
    { path: '/dispensestatistics/:solvent', component: DispenseStatistics },
    { path: '/configadmintool', component: ConfigAdminTool },
    { path: '/layoutviewer', component: LayoutViewer },
    { path: '/missingconsumables', component: MissingConsumables },
    { path: '/machinesettings', component: MachineSettings },
    { path: '/empower', component: Empower },
    { path: '/jog', component: Jog },
    { path: '/workflowarchive', component: WorkflowArchive },
    //{ path: '', redirect: '/sequencetable' }
    { path: '/', component: Samples },
    { path: '/usersettings', component: UserSettings },
    { path: '/allusersettings', component: AllUserSettings },
    { path: '/userlog', component: UserLog },
    { path: '/ticket', component: Ticket },
    { path: '/releasenotes', component: ReleaseNotes },
    { path: '/vialReposition', component: VialReposition },*/
  ]
})



router.beforeEach((to, from, next) => {
    router.app.$notify({
        type: 'warn',
        text: 'This instance of accroma is in demo mode. Changing screens is not possible.',
    });
    if(to.path === '/'){
        next();
    }else{
        next(false);
    }
})

export default router;